import LoginModal from '@/components/loginModalV2.vue'
import eventBus from '@/utils/eventBus'

export default {
  install (Vue) {
    // 创建组件构造器
    const LoginModalConstructor = Vue.extend(LoginModal)

    // 实例化组件
    const instance = new LoginModalConstructor()

    // 手动挂载到body
    instance.$mount()
    document.body.appendChild(instance.$el)

    // 注册全局方法
    Vue.prototype.$login = {
      show: () => instance.show(),
      hide: () => instance.hide()
    }

    // 注册全局事件监听
    eventBus.$on('show-login', () => instance.show())
  }
}
